import { useSelector } from 'react-redux';
import { TReducerRootState } from 'redux/types';

const useEnabled2FA = () => {
    return useSelector<TReducerRootState, boolean>(
        (state) => !!state.app.currentSessionData.isEnabled2FA,
    );
};

export default useEnabled2FA;
